import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'hooks';
import { PayloadState } from 'interfaces';
import { refresh } from 'store/thunks';
import { ROUTES } from 'constants/routes';

export function PrivateRoute() {
  const { refreshRequestState } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(refresh());
  }, []);

  useEffect(() => {
    if (refreshRequestState === PayloadState.rejected) {
      navigate(ROUTES.login);
    }
  }, [refreshRequestState]);
}
